import React from 'react'
// Tools
import { useLazyLoad } from '@navent-jobs/ui-kit/hooks/lazy-loading'
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'

// Components
import { MainContainer, Col, Row } from '@navent-jobs/ui-kit/components/grid'
import NotLogedUserSuggest from './not-logged-user-suggest'

// Styles
import { ComponentWrapper, GreyBard, Lazy } from './mixins'

const SuggestionForUser = () => {
  const { isDesktop, isTabletLandscape } = useWindowSize()
  const { isVisible, containerRef } = useLazyLoad()

  return (
    <Lazy ref={containerRef}>
      {isVisible && (
        <ComponentWrapper>
          <GreyBard />
          <MainContainer>
            <Row>
              <Col xs={12}>
                <NotLogedUserSuggest />
              </Col>
            </Row>
          </MainContainer>
          {(isDesktop || isTabletLandscape) && <GreyBard />}
        </ComponentWrapper>
      )}
    </Lazy>
  )
}

export default SuggestionForUser
